import { render, staticRenderFns } from "./jsonData.vue?vue&type=template&id=ce5cb426&"
import script from "./jsonData.vue?vue&type=script&lang=js&"
export * from "./jsonData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports